import React from 'react';

function DynamicEta({
    countdownHours,
    countdownMins,
    countdownSecs=""
}) {

  return (
      <span className="countdown-timer">
            <span>
        { (countdownHours === "1" || countdownHours === 1) &&
                (<span> {countdownHours} hour </span>)}
        </span>
        <span>
        { (countdownHours > "1") &&
                (<span> {countdownHours} hours </span>)}
        </span>

        <span>
            { (countdownMins === "1" || countdownMins === 1) &&
            (<span> {countdownMins} min </span>)}
        </span>
        <span>
            { (countdownMins > "1") &&
                    (<span> {countdownMins} mins </span>)}
        </span>
    </span>
  );


}

export default DynamicEta;